<template>
    <lu-vbox lu-flex sv-if='searchExpanded' class='riskSettingsPanel' >

      <!-- <PageTitle :title='$t("Settings")' @togglePageTitle='togglePageTitle' :hasClose='true'/> -->
    <lu-hbox lu-hcenter style='margin-top: 10px;' class='title'>
      <lu-item :class='resizeFont("title2", "divTitle")'>{{ $t('Settings') }}</lu-item>
    </lu-hbox>


      <lu-scroll-area lu-flex :scrollbarWidth='10' >

      <lu-vbox lu-vcenter class='vpad-in-20' style='margin-top: 20px; margin-left: 10px;'>


          <lu-vbox>
            <PageTitle :title='$t("Broker Environments")' @toggleClose='envToggleClose'/>
            <lu-hbox lu-flex>
              <lu-hbox lu-flex-wrap style='margin-right: 10px;' v-if='envExpanded'>

                <lu-hbox class='menu-tree-row el-tree el-tree-node__content'>
                  <lu-item     style='width: 150px;'  class='menu-tree-node-label settingsLabel'>{{ $t('All') }}</lu-item>
                  <el-checkbox :disabled="brokerListSelect.length ===0" class='menu-tree-node-content' v-model="checkAllBroker"/>
                </lu-hbox>

                <!-- <lu-hbox class='menu-tree-row el-tree el-tree-node__content' v-for="env in brokerListSelect" :label="env.label" :key="env.functionId" v-if='isBrokerAllowed(env.label)'> -->
                <lu-hbox class='menu-tree-row el-tree el-tree-node__content' v-for="env in brokerListSelect" :label="env.label" :key="env.functionId">
                  <template v-if='isBrokerAllowed(env.label)'>
                    <lu-item     style='width: 150px;'  :style='{ cursor: !isBrokerAllowed(env.label) ? "not-allowed" : "pointer" }' class='menu-tree-node-label settingsLabel'>{{ env.label }}</lu-item>
                    <el-checkbox :disabled="!isBrokerAllowed(env.label)" class='menu-tree-node-content' v-model="env.isAllowed"/>
                  </template>
                </lu-hbox>
              </lu-hbox>
              <lu-hbox lu-flex />
            </lu-hbox>
          </lu-vbox>

          <lu-vbox>
            <PageTitle :title='$t("Currency")' @toggleClose='currencyToggleClose'/>
            <lu-hbox>
              <lu-hbox lu-flex />
              <lu-hbox style='margin: 10px;' v-if='currencyExpanded'>
                <el-select v-model="form.currency" placeholder="Currency">
                    <el-option v-for='item in currencyList' :key='item' :label='item' :value='item' />
                </el-select>
              </lu-hbox>
            </lu-hbox>
          </lu-vbox>

          <lu-vbox>
            <PageTitle :title='$t("Panels")' @toggleClose='panelToggleClose'/>

            <lu-hbox lu-flex-wrap style='margin-right: 10px;' v-if='panelExpanded'>
              <lu-hbox class=' menu-tree-row el-tree el-tree-node__content'>
                <lu-item  style='width: 200px;'   class='menu-tree-node-label settingsLabel'>{{ $t('All') }}</lu-item>
                <!-- <el-checkbox :disabled="panelList.length ===0" class='menu-tree-node-content' v-model="checkAllPanel"/> -->
                <el-checkbox :disabled="panelList.length ===0" class='menu-tree-node-content' @change='togglePanelAll'  :value='checkAllPanel'/>
              </lu-hbox>

              <lu-hbox lu-flex-wrap lu-flex class='el-tree-node__content' v-for="panel in panelList" :key="panel.id" >
                <lu-item style='width: 200px;' @click.stop='togglePanel(panel.id)' class='menu-tree-node-label settingsLabel'>{{ panel.options.title }} </lu-item>
                <el-checkbox class='menu-tree-node-content'  @change='togglePanel(panel.id)'   :value="displayedPanels[panel.id]"/>
              </lu-hbox>

            </lu-hbox>
          </lu-vbox>



          <lu-vbox>
            <PageTitle :title='$t("Data parameters")' @toggleClose='paramToggleClose'/>

            <lu-hbox lu-flex-wrap class='vpad-in-5' style='margin-right: 10px;' v-if='paramExpanded'>

              <lu-vbox lu-flex class='vpad-in-5' lu-vcenter  v-for="group in groupingList" :key='group.key'>
                <lu-hbox  class='menu-tree-row el-tree el-tree-node__content' >
                  <lu-item style='width: 170px;' class='menu-tree-node-label settingsLabel'>{{ $t(group.key) }} </lu-item>
                  <el-switch @change='changeGrouping(group.key)' v-model='groupingKeys[group.key]'
                    :active-value='group.values[0]' :inactive-value="group.values[1]"
                    :active-text='$t(group.values[0])' :inactive-text="$t(group.values[1])"
                    />
                </lu-hbox>
              </lu-vbox>
            </lu-hbox>
          </lu-vbox>

        <!-- <el-select @change='v => changeGrouping(group.key, v)' :value='groupingKeys[group.key]'>
                  <el-option v-for="val in group.values" :key='val' :label='$t(val)' :value='val'/>
                </el-select> -->
          <!-- <PageTitle2 :title='$t("Data grouping")'  >
            <lu-vbox style='margin:10px 40px;' class='vpad-in-5'  >
              <lu-hbox lu-vcenter class='menu-tree-row el-tree el-tree-node__content' v-for="group in groupingList" :key='group.key'>
                <lu-item style='width: 130px' class='menu-tree-node-label settingsLabel'>{{ $t(group.key) }} </lu-item>
                <el-checkbox v-for="val in group.values" :key='val' :label='$t(val)' class='menu-tree-node-content'  :value='val' @change='changeGrouping(group.key, val)'  />
              </lu-hbox>
            </lu-vbox>
          </PageTitle2> -->

          <lu-vbox>
            <PageTitle :title='$t("Options")' @toggleClose='optionToggleClose'/>

            <lu-vbox lu-flex-wrap class='vpad-in-5' style='margin-right:10px;'  v-if='optionExpanded'>

              <lu-hbox class='menu-tree-row el-tree el-tree-node__content' >
                <lu-item  style='width: 170px;' class='menu-tree-node-label settingsLabel'>{{ $t('Include Markups') }}</lu-item>
                <el-switch v-model='form.includeMarkups' inactive-color="#C0CCDA" />
              </lu-hbox>

              <lu-hbox  class='menu-tree-row el-tree el-tree-node__content'  >
                <lu-item  style='width: 170px;' class='menu-tree-node-label  settingsLabel'>{{ $t('Sound') }}</lu-item>
                <el-switch v-model='form.isSound' inactive-color="#C0CCDA" />
              </lu-hbox>

              <lu-hbox  class='menu-tree-row el-tree el-tree-node__content' >
                <lu-item  style='width: 120px;' @ class='menu-tree-node-label settingsLabel'>{{ $t('Limit count') }}</lu-item>
                <el-select v-model="form.count" placeholder="Limit count">
                  <el-option key='10' label='10' value=10></el-option>
                  <el-option key='15' label='15' value=15></el-option>
                  <el-option key='20' label='20' value=20></el-option>
                  <el-option key='30' label='30' value=30></el-option>
                  <el-option key='50' label='50' value=50></el-option>
                </el-select>
              </lu-hbox>

            </lu-vbox>
          </lu-vbox>


      </lu-vbox>
      </lu-scroll-area>
    </lu-vbox>


</template>

<script>
import { LuScrollArea, LuHbox, LuVbox, LuItem } from 'lusis-ui'
import PageTitle from '@/components/PageTitle'
import { mapGetters, mapState } from 'vuex'
import utilsMixin from '@/mixins/utils'
import { deepClone } from '@/utils'

export default {
  name: 'settingsMonitor',
  mixins: [ utilsMixin ],
  components: { PageTitle, LuScrollArea, LuHbox, LuVbox, LuItem },
  provide: function () {
    return {
      '$settings': this
    }
  },
  props: [ 'panelList', 'displayed', 'currencyList', 'groupingList', 'groupingKeys' ],
  data () {
    return {
      'searchExpanded': false,
      envExpanded: true,
      currencyExpanded: true,
      panelExpanded: true,
      paramExpanded: true,
      optionExpanded: true,
      checkAllBroker: false,
      // checkAllPanel: false,
      form: {
        includeMarkups: false,
        isSound: false,
        count: 10,
        currency: undefined
      },
      conditions: {},
      localBrokerList: [],
      isReady: false,
    }
  },
  mounted: function () {
    this.$nextTick().then(() => {
      this.updateCheckAllValue()
      this.isReady = true
      this.form.currency = this.currencySelected,
      this.form.includeMarkups = this.includeMarkupsVal
      this.form.isSound = this.isSoundVal,
      this.form.count = this.countVal
    })
  },
  created () {
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.saveSettingsBrokerList)
  },
  beforeDestroy() {
    this.saveSettingsBrokerList()
    window.removeEventListener("beforeunload", this.saveSettingsBrokerList)
  },
  methods: {
    toggleExpand: function () {
      this.searchExpanded = !this.searchExpanded
      if (this.searchExpanded) {
        this.envExpanded = true
        this.panelExpanded = true
      }
    },
    panelToggleClose: function () {
      this.panelExpanded = !this.panelExpanded
    },
    paramToggleClose: function () {
      this.paramExpanded = !this.paramExpanded
    },
    optionToggleClose: function () {
      this.optionExpanded = !this.optionExpanded
    },
    envToggleClose: function () {
      this.envExpanded = !this.envExpanded
    },
    currencyToggleClose: function () {
      this.currencyExpanded = !this.currencyExpanded
    },
    togglePageTitle: function () {
      this.searchExpanded = !this.searchExpanded
    },
    open: function () {
      this.searchExpanded = true
    },
    close: function () {
      this.searchExpanded = false
    },
    envClose: function () {
      this.envExpanded = !this.envExpanded
    },
    panelClose: function () {
      this.panelExpanded = !this.panelExpanded
    },
    optionClose: function () {
      this.optionExpanded = !this.optionExpanded
    },
    isBrokerAllowed: function (label) {
      return this.$acl.isAllowedBroker(label)
    },
    togglePanelAll: function (selected) {
      this.$emit('togglePanel', { force: true, selected: selected })
    },
    togglePanel: function (id) {
      this.$emit('togglePanel', { 'id': id })
    },
    isPanelOpen: function (id) {
      return this.displayed.findIndex(p => p.id === id) !== -1
    },
    selectedBrokerEnv: function () {
      return this.conditions['brokerList'].length
    },
    reload: function () {
      if (this.conditions['brokerList'].length) {
        this.$emit('iRiskUnsubscribe', false)
        this.$emit('iRiskSubscribe', this.conditions)
      }
    },
    changeGrouping: function () {
      this.$store.dispatch('settingsMonitor/changeSetting', {
        key: 'changeGrouping',
        value: this.groupingKeys
      })
      this.onTango()
    },
    saveSettingsBrokerList: function() {
      this.$store.dispatch('settingsMonitor/changeSetting', {
        key: 'settingsBrokerList',
        value: deepClone(this.localBrokerList)
      })
    },
    isTheSame: function (a, b) {
      if (a === null) {
        return b === null
      }
      else if (a === undefined) {
        return b === undefined
      }
      else if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false
        if (a.length != b.length) return false
        for (let idx = 0; idx < a.length; ++idx) {
          if (!this.isTheSame(a[idx], b[idx])) return false
        }
        return true
      }
      else if (typeof a === 'object') {
        if (typeof b !== 'object') return false
        for (let p in a) {
          if (!this.isTheSame(a[p], b[p])) return false
        }
        for (let p in b) {
          if (!this.isTheSame(a[p], b[p])) return false
        }
        return true
      }
      else {
        return a === b
      }
    },
    onTango: function () {
      if (!this.isReady) return

      let cond = {}
      cond['brokerList'] = this.brokerListSelect.filter(item => {
        if (!item.isAllowed) this.checkAllBroker = false
        return item.isAllowed ? item : null
      }).map(item => {
        return { 'brokerName': item.label }
      })
      cond['customerOrderId'] = this.userInfos.netId
      //cond['count'] = 50 // this.form.count
      cond['count']  = this.form.count
      if (this.form.currency) cond['currency'] = this.form.currency
      cond['includeMarkups'] = this.form.includeMarkups ? 1 : 0
      cond['parameterList'] = []
      for (let k in this.groupingKeys) {
        cond['parameterList'].push({
          paramName: k,
          paramValue: this.groupingKeys[k]
        })
      }

      let wasNotEmpty = this.conditions['brokerList'] && this.conditions['brokerList'].length
      let refresh = false
      const keys = [ 'brokerList', 'customerOrderId', 'count', 'currency', 'parameterList', 'includeMarkups' ]
      keys.forEach(k => {
        if (!this.isTheSame(cond[k], this.conditions[k])) {
          if (cond[k] !== undefined) {
            this.conditions[k] = cond[k]
          }
          else {
            delete this.conditions[k]
          }
          refresh = true
        }
      })
      if (refresh) {
        if (this.conditions['brokerList'].length) {
          this.$emit('iRiskUnsubscribe', false)
          this.$emit('iRiskSubscribe', this.conditions)
          this.$emit('openPage', true)
        }
        else {
          this.$emit('iRiskUnsubscribe', wasNotEmpty)
          this.$emit('openPage', false)
        }
      }
    },
    updateCheckAllValue: function () {
      this.checkAllBroker = this.brokerListSelect.findIndex(item => !item.isAllowed) === -1 ? true : false
    }
  },
  watch: {
    brokerListSelect: {
      handler: function () {
        this.onTango()
      },
      deep: true,
      immediate: true
    },
    checkAllBroker: function (selected) {
      if (selected) this.brokerListSelect = selected
    },
    /*
    checkAllPanel: function (selected) {
      this.$emit('togglePanel', { force: true, selected: selected })
    },
    */
    'form': {
      handler: function () {
        this.onTango()
        //this.$emit('limitCount', this.form.count)
      },
      deep: true,
      immediate: true
    },
    'form.currency': function (val) {
      this.$store.dispatch('settingsMonitor/changeSetting', {
        key: 'currency',
        value: val
      })
    },
    'form.includeMarkups': function (val) {
      this.$store.dispatch('settingsMonitor/changeSetting', {
        key: 'includeMarkups',
        value: val
      })
    },
    'form.isSound': function (val) {
      this.$store.dispatch('settingsMonitor/changeSetting', {
        key: 'isSound',
        value: val
      })
    },
    'form.count': function (val) {
      this.$store.dispatch('settingsMonitor/changeSetting', {
        key: 'count',
        value: val
      })
    }
  },
  computed: {
    ...mapGetters([ 'brokerList', 'userInfos' ]),
    ...mapState({
      currencySelected: state => state.settingsMonitor.settingParams.currency,
      groupKeys: state => state.settingsMonitor.settingParams.changeGrouping,
      includeMarkupsVal: state => state.settingsMonitor.settingParams.includeMarkups,
      isSoundVal: state => state.settingsMonitor.settingParams.isSound,
      countVal: state => state.settingsMonitor.settingParams.count,
      settingsBrokerList: state => state.settingsMonitor.settingParams.settingsBrokerList
    }),
    createOrUpdate: function () {
      return this.$t('I-RISK MONITOR')
    },
    brokerListSelect: {
      get: function () {
        let arr = []
        this.brokerList.forEach(b2 => {
          b2.brokerList.forEach(b => {
            if (b.status === 1 && this.$acl.isAllowedBroker(b.label)) {
              var idx = this.settingsBrokerList.findIndex(item => item.functionId === b.functionId)
              if (idx !== -1) {
                arr.push({
                  functionId: b.functionId,
                  label: b.label,
                  isAllowed: this.settingsBrokerList[idx].isAllowed
                })
              } else {
                arr.push({
                  functionId: b.functionId,
                  label: b.label,
                  isAllowed: true
                })
              }
            }
          })
        })

        // this.localBrokerList = arr
        // return this.localBrokerList
        this.$set(this, 'localBrokerList', arr)
        return arr
      },
      set: function (force) {
        this.localBrokerList.forEach(b => b.isAllowed = force)
      }
    },
    displayedPanels: function () {
      let val = {}
      // this.checkAllPanel = true
      this.panelList.forEach(p => {
        let setVal = this.displayed.findIndex(p2 => p2.id === p.id) !== -1
        // if (!setVal) {
          // this.checkAllPanel = setVal
        // }
        this.$set(val, p.id, setVal)
      })
      return val
    },
    checkAllPanel: function () {
      let currentCheckAll = true
      // this.panelList.forEach(p => {
      //   let setVal = this.displayed.findIndex(p2 => p2.id === p.id) !== -1
      //   if (!setVal) {
      //     currentCheckAll = setVal
      //   }
      // })
      for (let i = 0; i < this.panelList.length; i++) {
        let p = this.panelList[i]
        if (p && this.displayed.findIndex(p2 => p2.id === p.id) === -1) {
          currentCheckAll = false
          break
        }
      }

      return currentCheckAll
    }
  }
}
</script>

<style scoped>
.riskSettingsPanel {
  /* margin-right: 10px; */
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
}

.settingsLabel {
  justify-content: flex-end;
  margin-right: 20px;
  min-width: unset;
  white-space: nowrap;
}

</style>

